module.exports = __webpack_public_path__ + "static/media/demoAsteroide.5828f3e7.jpg";